import React, { useContext, useState } from "react";
import { Grid } from "@mui/material";
import stylesCss, { Tittle } from "../style";
import { Button } from "@mui/material";
import { ContactContext } from "../../../../../context/contact/ContactContext";
import { useTranslation } from "react-i18next";
import UpdateDialog from "../../Approvals/secondAccounts/updateDialog";

const StepThree = ({ setActiveStep }) => {
  const { t } = useTranslation();
  const classesSx = stylesCss;
  const {
    primaryContact,
    submitApproval,
    createPrimaryContact,
    approvalSent,
    createVendorInformation,
  } = useContext(ContactContext);
  const [dialogUpdate, setShowDialogUpdate] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 2);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSendApproval = async () => {
    setShowDialogUpdate(true);
    await Promise.all([submitApproval()]);

    setSuccess(true);
    setTimeout(() => {
      setShowDialogUpdate(false);
    }, 1500);
    // await Promise.all([submitApproval(), createVendorInformation()]);

    handleNext();
  };

  const handleAssignPrimaryContact = async () => {
    // console.log("Usuario asignado");
    // await Promise.all([createContact(1), createVendorInformation()]);
    // await Promise.all([createPrimaryContact()]);
    // handleNext();
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  return (
    <>
      {dialogUpdate && (
        <UpdateDialog
          success={success}
          showDialogUpdate={dialogUpdate}
          setShowDialogUpdate={setShowDialogUpdate}
        />
      )}
      <br />
      <Tittle>{t("primaryUser")}</Tittle>
      <br />
      <br />
      {Object.keys(primaryContact).length > 0 ? (
        <div>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <Grid container spacing={4}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <label htmlFor="inputEmail4">{t("name")}</label>
                  <input
                    type="text"
                    className="form-control"
                    id="inputEmail4"
                    placeholder={t("name")}
                    value={primaryContact.givenName}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <label htmlFor="inputPassword4">{t("lastName")}</label>
                  <input
                    type="text"
                    className="form-control"
                    id="inputEmail4"
                    placeholder={t("lastName")}
                    value={primaryContact.surname}
                    disabled
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      ) : (
        <div>
          <br />
          <h3>{t("noAssignedPrimaryUser")}</h3>
          <br />
        </div>
      )}
      <br />
      <br />
      <Grid container spacing={2} padding={2}>
        <Grid item xs={12} md={12} lg={12}>
          <Grid container spacing={5}>
            <Grid
              item
              xs={6}
              md={6}
              lg={6}
              sx={{
                ...classesSx.gridBtnRegresar,
              }}
            >
              <Button
                sx={{ ...classesSx.btnBuscarRegresar }}
                variant="contained"
                onClick={handleBack}
              >
                {t("back")}
              </Button>
            </Grid>
            <Grid
              item
              xs={6}
              md={6}
              lg={6}
              sx={{
                ...classesSx.gridBtnContinuar,
              }}
            >
              {Object.keys(primaryContact).length > 0 ? (
                <Button
                  sx={{ ...classesSx.btnBuscarRegresar }}
                  type="submit"
                  disabled={!(Object.keys(primaryContact).length > 0)}
                  variant="contained"
                  onClick={handleSendApproval}
                >
                  {t("submitApproval")}
                </Button>
              ) : (
                <Button
                  sx={{ ...classesSx.btnBuscarRegresar }}
                  type="submit"
                  variant="contained"
                  onClick={handleAssignPrimaryContact}
                >
                  {t("assignPrimaryUser")}
                </Button>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default StepThree;
